import { render } from "./StudentHeader.vue?vue&type=template&id=8c434574&scoped=true"
import script from "./StudentHeader.vue?vue&type=script&lang=js"
export * from "./StudentHeader.vue?vue&type=script&lang=js"

import "./StudentHeader.vue?vue&type=style&index=0&id=8c434574&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c434574"]])

export default __exports__